"use client"

import { useEffect, useState } from "react"

export function useMediaQuery(query: string) {
  const getMatches = () => {
    if (typeof window === "undefined") return false
    if (typeof window.matchMedia !== "function") return false
    return window.matchMedia(query).matches
  }

  const [value, setValue] = useState(getMatches)

  useEffect(() => {
    if (typeof window === "undefined") return
    if (typeof window.matchMedia !== "function") return

    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches)
    }

    const result = window.matchMedia(query)
    result.addEventListener("change", onChange)
    setValue(result.matches)

    return () => result.removeEventListener("change", onChange)
  }, [query])

  return value
}